var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"show-arrows":"","height":"35"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'salaries'
            }}},[_vm._v(" تفاصيل الراتب ")]),_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'salaries-view'
            }}},[_vm._v(" الراتب ")]),_c('v-tabs-slider',{attrs:{"color":"primary"}})],1),_c('v-divider',{staticClass:"mb-2"}),(_vm.loading)?_c('loader'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }